module.exports = __webpack_public_path__ + "media/images/emblems/Neuendorf-blason-4d1df2a601a280cc0a946c493d958542.png";